// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2S_T-","info":"Note_info__8LtyY","note":"Note_note__3DD3K","actions":"Note_actions__W6seP"};